import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PublicHolidays } from '@/features/public-holidays'

const publicHolidaysSearchSchema = z.object({
  state: z.string().optional(),
  year: z.number().optional(),
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(20),
})

export const Route = createFileRoute('/_authenticated/_organization/public-holidays/')({
  component: PublicHolidays,
  validateSearch: publicHolidaysSearchSchema,
})

